module.exports = __webpack_public_path__ + "static/media/userSubscribed.3775ab28.svg";